import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ConsumptionsFormGroup, ElectricityFormGroup, NaturalGasFormGroup } from '../opportunity-form.component';
import * as dateFns from 'date-fns'
import * as _ from 'lodash';
import { eletricityConsumptionTypes_BTN_SimplePT, eletricityConsumptionTypes_BTNPT, eletricityConsumptionTypesES, eletricityConsumptionTypesPT, naturalGasConsumptionTypesES, naturalGasConsumptionTypesPT } from 'src/app/constants';
import { UsersService } from 'src/app/services/users.service';
import { DatePickerType } from 'is-lib';

@Component({
    selector: 'app-consumptions',
    templateUrl: './consumptions.component.html',
    styleUrls: ['./consumptions.component.scss']
})
export class ConsumptionsComponent implements OnInit, OnChanges {
    @Input() consumptionsFormArray: FormArray<FormGroup<ConsumptionsFormGroup>> = new FormArray<FormGroup<ConsumptionsFormGroup>>([]);
    @Input() allowsPriceInput: boolean = false;
    @Input() singleMonthConsumptionInput: boolean = false;
    @Input() isElectricity!: boolean;

    possibleConsumptionInputs: any = undefined;

    possiblePriceInputs: any = undefined;

    monthRange: Date[];
    sumTotal = 0;
    priceSumTotal = 0;

    datepickerType = DatePickerType.month;

    parentFormGroup?: FormGroup<any>;
    singleMonthInputFormGroup?: FormGroup<ConsumptionsFormGroup>;
    
    constructor(
        private _user: UsersService
    ) { 
        let endDate = dateFns.subMonths(new Date(), 2);
        let startDate = dateFns.subMonths(endDate, 11);

        this.monthRange = dateFns.eachMonthOfInterval({start: startDate, end: endDate});
    }

    ngOnInit(): void { 
        
        if (this.isElectricity) {
            this.parentFormGroup =(this.consumptionsFormArray.parent as FormGroup<ElectricityFormGroup>);

            if (this.parentFormGroupAsElectricity.controls.tensionLevelString.value == 'BTN') {
                if (this.parentFormGroupAsElectricity.controls.countTypeString.value?.toLocaleLowerCase() == 'simple' || this.parentFormGroupAsElectricity.controls.countTypeString.value?.toLocaleLowerCase() == 'simples') {
                    this.possibleConsumptionInputs = eletricityConsumptionTypes_BTN_SimplePT;
                    this.possiblePriceInputs = { PEAK:'peakEnergyPrice' };
                } else {
                    this.possibleConsumptionInputs = eletricityConsumptionTypes_BTNPT;
                    this.possiblePriceInputs = { PEAK:'peakEnergyPrice',  OFF_PEAK:'offPeakEnergyPrice', STANDARD: 'standardEnergyPrice' };
                }
            } else {
                this.possibleConsumptionInputs = this._user.userCountryCode == 'pt' ? eletricityConsumptionTypesPT : eletricityConsumptionTypesES;
                this.possiblePriceInputs = {
                    OFF_PEAK:'offPeakEnergyPrice', 
                    PEAK:'peakEnergyPrice', 
                    STANDARD: 'standardEnergyPrice', 
                    SUPER_OFF_PEAK: 'superOffPeakEnergyPrice'
                };
            }

        } else {
            this.parentFormGroup = (this.consumptionsFormArray.parent as FormGroup<NaturalGasFormGroup>)

            this.possibleConsumptionInputs = this._user.userCountryCode == 'pt' ? naturalGasConsumptionTypesPT : naturalGasConsumptionTypesES;
            this.possiblePriceInputs = { GAS: 'energyPrice' };
        }

        this.clearNonNeededInputs();

        if (this.singleMonthConsumptionInput) {
            this.singleMonthInputFormGroup = new FormGroup<ConsumptionsFormGroup>({
                date: new FormControl<Date | undefined>(undefined, {nonNullable: true}),
                offPeak: new FormControl<number | undefined>(undefined, {nonNullable: true, validators: this.isPossibleInput('offPeak') ? Validators.required : null}),
                peak: new FormControl<number | undefined>(undefined, {nonNullable: true, validators: this.isPossibleInput('peak') ? Validators.required : null}),
                standard: new FormControl<number | undefined>(undefined, {nonNullable: true, validators: this.isPossibleInput('standard') ? Validators.required : null}),
                superOffPeak: new FormControl<number | undefined>(undefined, {nonNullable: true, validators: this.isPossibleInput('superOffPeak') ? Validators.required : null}),
                gas: new FormControl<number | undefined>(undefined, {nonNullable: true, validators: this.isPossibleInput('gas') ? Validators.required : null}),
                id: new FormControl<number | undefined>(undefined, {nonNullable: true}),
                singleLine: new FormControl<boolean>(true, {nonNullable: true})
            });

            this.consumptionsFormArray.controls.push(this.singleMonthInputFormGroup);

            this.singleMonthInputFormGroup.valueChanges.subscribe( () => {
                this.calculateSums();
            });
        } else 
            if (this.consumptionsFormArray.controls.filter( (group: FormGroup<ConsumptionsFormGroup>) => !group.controls.singleLine.value ).length < this.monthRange.length) {

                this.monthRange.forEach( (month: Date) => {
                    if ( !this.consumptionsFormArray.controls.some( (fg: FormGroup<ConsumptionsFormGroup>) => new Date(fg.controls.date.value + 'Z').getTime() == month.getTime())) {
                        let newFormGroup = new FormGroup<ConsumptionsFormGroup>({
                            date: new FormControl<Date>(month, {nonNullable: true}),
                            offPeak: new FormControl<number | undefined>(undefined, {nonNullable: true, validators: this.isPossibleInput('offPeak') ? Validators.required : null}),
                            peak: new FormControl<number | undefined>(undefined, {nonNullable: true, validators: this.isPossibleInput('peak') ? Validators.required : null}),
                            standard: new FormControl<number | undefined>(undefined, {nonNullable: true, validators: this.isPossibleInput('standard') ? Validators.required : null}),
                            superOffPeak: new FormControl<number | undefined>(undefined, {nonNullable: true, validators: this.isPossibleInput('superOffPeak') ? Validators.required : null}),
                            gas: new FormControl<number | undefined>(undefined, {nonNullable: true, validators: this.isPossibleInput('gas') ? Validators.required : null}),
                            id: new FormControl<number | undefined>(undefined, {nonNullable: true}),
                            singleLine: new FormControl<boolean>(false, {nonNullable: true})
                        });
                        
                        this.consumptionsFormArray.controls.push(newFormGroup);

                        newFormGroup.valueChanges.subscribe( () => {
                            this.calculateSums();
                        });
                    }
                });
            }

        this.parentFormGroup.valueChanges.subscribe( () => {
            this.calculateSums();
        });

        this.calculateSums();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['singleMonthConsumptionInput'].previousValue != changes['singleMonthConsumptionInput'].currentValue && !changes['singleMonthConsumptionInput'].isFirstChange()) {
            if (changes['singleMonthConsumptionInput'].currentValue) {
                if (this.singleMonthInputFormGroup == null) {
                    this.singleMonthInputFormGroup = new FormGroup<ConsumptionsFormGroup>({
                        date: new FormControl<Date | undefined>(undefined, {nonNullable: true}),
                        offPeak: new FormControl<number | undefined>(undefined, {nonNullable: true, validators: this.isPossibleInput('offPeak') ? Validators.required : null}),
                        peak: new FormControl<number | undefined>(undefined, {nonNullable: true, validators: this.isPossibleInput('peak') ? Validators.required : null}),
                        standard: new FormControl<number | undefined>(undefined, {nonNullable: true, validators: this.isPossibleInput('standard') ? Validators.required : null}),
                        superOffPeak: new FormControl<number | undefined>(undefined, {nonNullable: true, validators: this.isPossibleInput('superOffPeak') ? Validators.required : null}),
                        gas: new FormControl<number | undefined>(undefined, {nonNullable: true, validators: this.isPossibleInput('gas') ? Validators.required : null}),
                        id: new FormControl<number | undefined>(undefined, {nonNullable: true}),
                        singleLine: new FormControl<boolean>(true, {nonNullable: true})
                    });
        
                    this.consumptionsFormArray.controls.push(this.singleMonthInputFormGroup);
        
                    this.singleMonthInputFormGroup.valueChanges.subscribe( () => {
                        this.calculateSums();
                    });
                }

                this.consumptionsFormArray.controls.forEach( (fg) => {
                    for (const key in fg.controls) {
                        if (this.isPossibleInput(key) && fg.controls.singleLine.value) {
                            fg.get(key)?.addValidators(Validators.required)
                        } else {
                            fg.get(key)?.clearValidators();
                        }
                        
                    }
                })
            } else {
                this.consumptionsFormArray.controls.forEach( (fg) => {
                    for (const key in fg.controls) {
                        if (this.isPossibleInput(key) && !fg.controls.singleLine.value) {
                            fg.get(key)?.addValidators(Validators.required)
                        } else {
                            fg.get(key)?.clearValidators();
                        }
                        
                    }
                })
            }
            this.consumptionsFormArray.updateValueAndValidity();
            this.calculateSums();
        }
        
    }

    protected copyPasteHandler(monthIndex: number, inputIndex: number, event: ClipboardEvent) {
        event.preventDefault();
        
        let regExPattern = new RegExp('(\\t|\\n\\r|\\r\\n|\\n|\\r)', 'g');
        let pastedData = event.clipboardData?.getData('text/plain');
        let treatedPastedData = pastedData?.replaceAll(regExPattern, ';').split(';');
        let monthlyConsumptions: FormGroup<ConsumptionsFormGroup>[] = this.consumptionsFormArray.controls;

        let possibleInputs: string[] = this.possibleConsumptionInputValues;

        if (treatedPastedData) {
            let monthCounter: number = monthIndex;
            let inputCounter: number = inputIndex;
            

            treatedPastedData.forEach( (pasteValue: string) => {
                if (monthCounter < monthlyConsumptions.length) {
                    let currentInput: string = possibleInputs[inputCounter];
                
                    monthlyConsumptions[monthCounter].get(currentInput)?.setValue(+pasteValue);
                    
                    inputCounter += 1;
                    
                    if (inputCounter == possibleInputs.length) {
                        inputCounter = 0;
                        monthCounter += 1;
                    }
                }
            });
        }
    }

    clearNonNeededInputs() {
        let arrayToSum = this.consumptionsFormArray.controls.filter( (consumption) => !consumption.controls.singleLine.value );

        arrayToSum.forEach( (obj: FormGroup<ConsumptionsFormGroup>) => Object.entries(obj.controls).forEach( ([key, control]) => {
            if (!this.possibleConsumptionInputValues.includes(key)) {
                switch (key) {
                    case 'offPeak': obj.controls.offPeak.setValue(undefined); break;
                    case 'peak': obj.controls.peak.setValue(undefined); break;
                    case 'standard': obj.controls.standard.setValue(undefined); break;
                    case 'superOffPeak': obj.controls.superOffPeak.setValue(undefined); break;
                    default: break;
                }
            }
        }) );

    }

    protected calculateSums() {
        let arrayToSum;
        if (this.singleMonthConsumptionInput) {
            arrayToSum = this.consumptionsFormArray.getRawValue().filter( (consumption) => consumption.singleLine )
        }
        else {
            arrayToSum = this.consumptionsFormArray.getRawValue().filter( (consumption) => !consumption.singleLine );
        }

        this.sumTotal = arrayToSum.reduce<number>((sum, obj) => {
            let totalFromObject = Object.entries(obj)
                .filter( ([key, value]) => this.possibleConsumptionInputValues.includes(key) && _.isFinite(value))
                .map(([key, value]) => (value ?? 0) as number)
                .reduce<number>((sum, value) => sum += value, 0)
            return sum + totalFromObject;
        }, 0)

        let formGroupValues = null;

        if (this.isElectricity) {
            formGroupValues = this.parentFormGroupAsElectricity.getRawValue();

        } else {
            formGroupValues = this.parentFormGroupAsNaturalGas.getRawValue();
        }

        this.priceSumTotal = Object.entries(formGroupValues)
                .filter( ([key, value]) => this.possiblePriceInputValues.includes(key) && _.isFinite(value))
                .map(([key, value]) => (value ?? 0) as number)
                .reduce<number>((sum, value) => sum + value, 0)
        
    }

    protected get parentFormGroupAsElectricity(): FormGroup<ElectricityFormGroup> {
        return this.parentFormGroup as FormGroup<ElectricityFormGroup>
    }

    protected get parentFormGroupAsNaturalGas(): FormGroup<NaturalGasFormGroup> {
        return this.parentFormGroup as FormGroup<NaturalGasFormGroup>
    }

    protected get possibleConsumptionInputKeys(): string[] {
        return this.possibleConsumptionInputs.map( (inp: any) => inp.key );
    }

    protected get possibleConsumptionInputValues(): string[] {
        return this.possibleConsumptionInputs.map( (inp: any) => inp.value );
    }

    protected get possiblePriceInputValues(): string[] {
        return Object.values(this.possiblePriceInputs);
    }

    protected isPossibleInput(keyName: string): boolean {
        return this.possibleConsumptionInputValues.includes(keyName);
    }
}
